export default "/status-success.5d12dcb9e83985c19a5c02d3c89612b3.svg";